import React, { useEffect } from "react";
import { Modal, Box, Typography, TextField, Button, Checkbox, FormControlLabel } from "@mui/material";
import { differenceInMinutes } from "date-fns";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker, TimePicker } from "@mui/x-date-pickers";
import { es } from "date-fns/locale"; 

const ModalCalculoHoras = ({
  open,
  onClose,
  selectedUser,
  calculoHoras,
  setCalculoHoras,
  onConfirm,
  remunerado
}) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const minutosAlmuerzo = calculoHoras?.minutosAlmuerzo || 0;

  // Calcular total de horas cuando cambian los campos
  const calcularHoras = () => {
  if (!calculoHoras.hora_inicio || !calculoHoras.hora_fin) return;

  let start = new Date(calculoHoras.hora_inicio);
  let end = new Date(calculoHoras.hora_fin);

  let minutos = differenceInMinutes(end, start);
  if (minutos < 0) minutos = 0;

  if (calculoHoras.descontarAlmuerzo) {
    minutos = Math.max(minutos - minutosAlmuerzo, 0);
  }

  const horas = minutos / 60;

  setCalculoHoras(prev => ({
    ...prev,
    minutos,
    horas: Number(horas.toFixed(2)),
    descuento: remunerado === "REMUNERADO" ? 0 : Math.round(horas * prev.valorHora),
  }));
};



const formatDateForMySQL = (date) => {
  if (!date) return null;
  const pad = (n) => (n < 10 ? "0" + n : n);
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
};


  useEffect(() => {
    calcularHoras();
  }, [
    calculoHoras.hora_inicio,
    calculoHoras.hora_fin,
    calculoHoras.descontarAlmuerzo
  ]);

  useEffect(() => {
    if (!open) {
      setCalculoHoras({
        hora_inicio: "",
        hora_fin: "",
        minutos: 0,
        horas: 0,
        descuento: 0,
        sueldo: selectedUser?.sueldo || 0,
        sueldoDia: selectedUser?.sueldoDia || 0,
        valorHora: selectedUser?.valorHora || 0,
        descontarAlmuerzo: false,
        minutosAlmuerzo: selectedUser?.minutosAlmuerzo || 0
      });
    }
  }, [open, selectedUser, setCalculoHoras]);

  const horaInicio = calculoHoras.hora_inicio ? new Date(calculoHoras.hora_inicio) : null;
  const horaFin = calculoHoras.hora_fin ? new Date(calculoHoras.hora_fin) : null;
  const horasInvalidas = horaInicio && horaFin && (horaFin <= horaInicio);



  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.5)" } }}
    >
      <Box
        sx={{
          backgroundColor: colors.primary[600],
          padding: "25px",
          width: "50vh",
          borderRadius: "15px",
        }}
      >
        <Typography variant="h4" mb={2}>
          Permiso por HORAS
        </Typography>

        <Typography>Funcionario: {selectedUser?.firstname} {selectedUser?.lastname}</Typography>
        <Typography>Sueldo: {calculoHoras.sueldo}</Typography>
        <Typography>Sueldo día: {Math.round(calculoHoras.sueldoDia)}</Typography>
        <Typography>Sueldo hora: {Math.round(calculoHoras.valorHora)}</Typography>
        <Typography>Almuerzo del funcionario: {minutosAlmuerzo} min</Typography>

        


        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
          {/* FECHA + HORA INICIO */}
        <Box sx={{display: "flex", gap: 2, mt: 2, mb: 2}}>
          <DateTimePicker
              ampm={false}
              label="Hora inicio"
              value={calculoHoras.hora_inicio ? new Date(calculoHoras.hora_inicio) : null}
              onChange={(newValue) =>
                setCalculoHoras(prev => ({
                  ...prev,
                  hora_inicio: newValue ? formatDateForMySQL(newValue) : ""
                }))
              }
              slotProps={{
                textField: {
                  error: horasInvalidas,
                  helperText: horasInvalidas ? "La hora inicio debe ser menor que la hora fin" : ""
                }
              }}
              renderInput={(params) => <TextField {...params} fullWidth sx={{ mt: 3 }} />} //
            />
            {/*Hora Fin*/}
            <TimePicker
              ampm={false}
              label="Hora fin"
              value={calculoHoras.hora_fin ? new Date(calculoHoras.hora_fin) : null}
              onChange={(newValue) => {
                if (!newValue) return;
              
                const fechaInicio = new Date(calculoHoras.hora_inicio);
                const fechaFin = new Date(fechaInicio);
              
                fechaFin.setHours(newValue.getHours());
                fechaFin.setMinutes(newValue.getMinutes());
              
                setCalculoHoras(prev => ({
                  ...prev,
                  hora_fin: formatDateForMySQL(fechaFin)
                }));
              }}
              slotProps={{
                textField: {
                  error: horasInvalidas,
                  helperText: horasInvalidas ? "La hora fin debe ser mayor que la hora inicio" : ""
                }
              }}
              renderInput={(params) => <TextField {...params} fullWidth sx={{ mt: 3 }} />}
            />
          </Box>
        </LocalizationProvider>

        {/* DESCONTAR ALMUERZO */}
        <FormControlLabel
          control={
            <Checkbox
              checked={calculoHoras.descontarAlmuerzo}
              onChange={(e) =>
                setCalculoHoras(prev => ({
                  ...prev,
                  descontarAlmuerzo: e.target.checked
                }))
              }
            />
          }
          label={`Descontar almuerzo (${minutosAlmuerzo} minutos)`}
          sx={{ mt: 2 }}
        />

        {/* RESULTADOS */}
        <Typography mt={3}>Minutos calculados: {calculoHoras.minutos}</Typography>
        <Typography>Horas calculadas: {calculoHoras.horas}</Typography>
        <Typography>Descuento total: {calculoHoras.descuento} Gs.</Typography>

        {horasInvalidas && (
          <Typography color="error" sx={{ mt: 2 }}>
            ⚠️ La hora fin debe ser mayor que la hora inicio y no pueden ser iguales.
          </Typography>
        )}


        <Box mt={3} display="flex" justifyContent="space-between">
          <Button variant="contained" color="error" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={onConfirm}
            disabled={!horaInicio || !horaFin || horasInvalidas}
          >
            Confirmar
          </Button>

        </Box>
      </Box>
    </Modal>
  );
};

export default ModalCalculoHoras;
